module.exports = __webpack_public_path__ + "img/kiet.cd580b2b.jpg";